<template>
  
  <div class="tabs-container ng-scope" style="padding-bottom:50px;margin-top:18px;">
    <div id="wrapperp">
      <ul class="nav nav-tabs">
        <li
          class="tabLi"
          v-for="(data,$index) in langData"
          :key="$index"
          :class="{'active':$index==0}"
        >
          <div class="tabDiv" @click="changeTab($index)"></div>
          <a
            :class="true?'tab'+$index:''"
            data-toggle="tab"
            :href="true?'#tab-'+$index:''"
            aria-expanded="true"
            @click="showTab($event,$index)"
          >{{ $t("message." + data) }}</a>
        </li>
      </ul>
    </div>
    <form method="get" class="form-horizontal" id="baseInfo" novalidate="novalidate">
      <div class="tab-content">
        <div
          :id="'tab-'+index"
          v-for="(langItem, index) in issueDetail.langMap"
          :key="index"
          class="tab-pane"
        >
          <div class="panel-body">
            <div class="ibox-content">
              <div class="form-group">
                <label class="col-sm-2 control-label">
                  {{$t('message.issueName')}}
                  <span style="color:red">*</span>
                </label>
                <div class="col-sm-10">
                  <div>
                    <input
                      type="text"
                      class="form-control"
                      v-model.trim="langItem.title"
                      v-validate="'required'"
                      data-vv-validate-on="blur"
                      :name="'title - '+langLabel(langItem.langCode)"
                      maxLength="30"
                    />
                  </div>
                  <label class="error">{{ errors.first('title - '+langLabel(langItem.langCode)) }}</label>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label">
                  {{$t('message.issueNumber')}}
                  <span style="color:red">*</span>
                </label>
                <div class="col-sm-10">
                  <div>
                    <input
                      type="number"
                      class="form-control"
                      v-model.trim="issueDetail.issueNumber"
                      v-validate="'required'"
                      data-vv-validate-on="blur"
                      :name="'Issue Number'"
                      max="9999999999"
                      min="0"
                    />
                  </div>
                  <label class="error">{{ errors.first('Issue Number') }}</label>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label">{{$t("message.Job function") }}<span style="color:red">*</span></label>
                <div class="col-sm-5 jstreeHeight">
                  <v-jstree :data="jobFunctionList" show-checkbox multiple allow-batch whole-row @item-click="jobFunctionClick"></v-jstree>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label">{{$t("message.occupation") }}<span style="color:red">*</span></label>
                <div class="col-sm-5 jstreeHeight">
                  <v-jstree :data="occupationList" show-checkbox multiple allow-batch whole-row @item-click="occupationClick"></v-jstree>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label">{{$t("message.Status") }}<span style="color:red">*</span></label>
                <div class="col-sm-5">
                  <div>
                    <select class="form-control" v-model="issueDetail.status" v-validate="'required'" :name="'Status'">
                      <option value="0" class="ng-binding">{{$t("message.Draft") }} </option>
                      <option value="10" class="ng-binding">{{$t("message.Published") }}</option>
                    </select>
                  </div>
                  <label class="error">{{ errors.first('Status') }}</label>
                </div>
              </div>
              <div class="hr-line-dashed"></div>
              <div class="form-group">
                <div class="col-sm-12">
                  <div class="pull-right">
                    <div class="btn btn-primary" @click="submit()">{{$t("message.Save") }}</div>
                    <div class="btn btn-white" @click="showWarning()">{{$t("message.Cancel") }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>
<script>
import eventBus from "../eventbus";
import config from "../config";
import VJstree from 'vue-jstree'

export default {
  mixins: [config.globalMixin],
  data() {
    return {
      categoryId:"",
      issueDetail:{
        categoryId:''
      },
      categoryList:[],
      occupationIds: [],
      occupationList: [],
      jobFunctionIds:[],
      jobFunctionList:[]
    };
  },
  created() {
    let langMap = [];
    this.langKey.forEach(element => {
      langMap.push({ langCode: element });
    });
    this.issueDetail.langMap = langMap;
    this.init();
  },
  mounted() {
    setTimeout(function(){
      $(".tab" + 1)
        .parent()
        .find("a")
        .click();

      $(".tab" + 0)
        .parent()
        .find("a")
        .click();
    })
  },
  components: {
    VJstree
  },
  methods: {
    async init() {
      let id = this.$route.query.id;
      if (id) {
        let obj = this.getAuthObj;
        obj.magazineId = id;
        let data = await this.$store.dispatch("getMagazineDetail", this.setFormData(obj));
        let occupation = data.data.result.occupationList;
        for(var i=0;i<occupation.length;i++){
          var canAddO=true;
          for(var j=0;j<this.occupationIds.length;j++){
            if(this.occupationIds[j]==occupation[i].id){
              canAddO = false;
            }
          }
          if(canAddO){
            this.occupationIds.push(occupation[i].id);
          }
          var canAddJ=true;
          for(var j=0;j<this.jobFunctionIds.length;j++){
            if(this.jobFunctionIds[j]==occupation[i].jobFunctionId){
              canAddJ = false;
            }
          }
          if(canAddJ){
            this.jobFunctionIds.push(occupation[i].jobFunctionId);
          }
        }
        var langMap = [];
        this.langKey.forEach(element => {
          for(var i=0;i<data.data.result.langMap.length;i++){
            if(data.data.result.langMap[i].langCode==element){
              langMap.push(data.data.result.langMap[i])
            }
          }
        });
        data.data.result.langMap = langMap;
        this.$set(this, "issueDetail", data.data.result);
        this.getOccupationList();
      } else {
      }
      this.getJobFunctionList();
    },
    async getJobFunctionList(){
        let obj = this.getAuthObj;
        let data = await this.$store.dispatch("getJobFunctionList", this.setFormData(obj));
        let jobFunc = data.data.result;
        for(var i=0;i<jobFunc.length;i++){
          jobFunc[i].selected = false;
          for(var k=0;k<this.jobFunctionIds.length;k++){
            if(jobFunc[i].id==this.jobFunctionIds[k]){
              jobFunc[i].selected = true;
            }
          }
          for(var j=0;j<jobFunc[i].langMap.length;j++){
            if(jobFunc[i].langMap[j].langCode=="en_US"){
              jobFunc[i].name = jobFunc[i].langMap[j].title;
            }
          }
        }
        let jobFunctionList = [];
        for(var i=0;i<jobFunc.length;i++){
          jobFunctionList.push({
            "id": jobFunc[i].id,
            "text": jobFunc[i].name,
            "selected":jobFunc[i].selected,
            children: []
          })
        }
        this.$set(this, "jobFunctionList", jobFunctionList);
    },
    async getOccupationList(){
        let obj = this.getAuthObj;
        if(this.jobFunctionIds.length ==0){
          return;
        }
        obj.jobFunctionIds = this.jobFunctionIds.join(',');
        let data = await this.$store.dispatch("getOccupationList", this.setFormData(obj));
        let occupation = data.data.result;
        for(var i=0;i<occupation.length;i++){
          occupation[i].selected = false;
          for(var k=0;k<this.occupationIds.length;k++){
            if(occupation[i].id==this.occupationIds[k]){
              occupation[i].selected = true;
            }
          }
          for(var j=0;j<occupation[i].langMap.length;j++){
            if(occupation[i].langMap[j].langCode=="en_US"){
              occupation[i].name = occupation[i].langMap[j].title;
            }
          }
        }
        let occupationList = [];
        for(var i=0;i<occupation.length;i++){
          occupationList.push({
            "id": occupation[i].id,
            "text": occupation[i].name,
            "selected":occupation[i].selected,
            children: []
          })
        }
        this.$set(this, "occupationList", occupationList);
    },
    showWarning(type) {
      var that = this;
      if (!type) {
        that.$router.go(-1);
      } else if (type == 1) {
        this.$store.commit("setwarning", {
          string: this.$i18n.t("message.deleteContent"),
          boolean: true,
          button: [{
              name:this.$i18n.t("message.Confirm"),
              callBack:function(){
                that.callDelete();
              }
            }, {
              name:this.$i18n.t("message.Cancel"),
              callBack:function(){
                that.$store.commit("setwarning", {
                  string: "",
                  boolean: false,
                });
              }
            }]
        });
      }
    },
    async submit() {
      try {
        let vresult = await this.$validator.validate();
        if (!vresult) {
          this.fillInRequired();
          return;
        }
        let obj = this.getAuthObj;
        for(var key in this.issueDetail){
          obj[key] = this.issueDetail[key];
        }
        obj.langData = JSON.stringify(obj.langMap);
        let occupationIds = [];
        for(var i=0;i<this.occupationList.length;i++){
          if(this.occupationList[i].selected){
            occupationIds.push(this.occupationList[i].id);
          }
        }
        if(occupationIds.length<5){
          this.$toastr.w(this.$i18n.t("message.Minimum 5 occupation"),"Warning");
          return;
        }
        obj.occupationIds = occupationIds;
        if(this.$route.query.id){
           var  data = await this.$store.dispatch("updateMagazine", this.setFormData(obj));
        }else{
           var  data = await this.$store.dispatch("createMagazine", this.setFormData(obj));
        }
        
        if (data.data.errorCode === 0) {
          this.$router.go(-1);
        }
      } catch (err) {
        console.error(err);
      }
    },
    Delete() {
      this.showWarning(1);
    },
    async callDelete() {
      try {
        let obj = this.getAuthObj;
        obj.magazineIds = [this.$route.query.id];
        let data = await this.$store.dispatch("deleteMagazine", this.setFormData(obj));
        if (data.data.errorCode === 0) {
          this.$router.go(-1);
        }
      } catch (err) {
        console.error(err);
      }
    },
    langLabel(lang) {
      if (lang === "en_US") {
        return "EN";
      } else if (lang === "zh_HK") {
        return "T. Chi.";
      } else if (lang === "zh_CN") {
        return "S. Chi.";
      }
    },
    changeTab: function(id) {
      $(".tab" + id)
        .parent()
        .find("a")
        .click();
    },
    showTab: function($event, tabId) {
      $event.preventDefault();
      switch (tabId) {
        case "1":
          $scope.tab1 = true;
          $($event.target).tab("show");
          break;
        case "2":
          $scope.tab2 = true;
          $($event.target).tab("show");
          break;
      }
    },
    jobFunctionClick(){
      this.jobFunctionIds = [];
      for(var i=0;i<this.jobFunctionList.length;i++){
        if(this.jobFunctionList[i].selected){
          this.jobFunctionIds.push(this.jobFunctionList[i].id);
        }
      }
      this.getOccupationList();
    },
    occupationClick(){
      this.occupationIds = [];
      for(var i=0;i<this.occupationList.length;i++){
        if(this.occupationList[i].selected){
          this.occupationIds.push(this.occupationList[i].id);
        }
      }
    }
  }
};
</script>
